export default "__VITE_ASSET__5icc19oX__"